import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import NoListProv from "./NoListProv/NoListProv";
import "./ListProv.css";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import NavbarSupplier from "../NavbarSupplier/NavbarSupplier";
import FooterIndex from "../../components/footerHomePage/footerHomePage";
import moment from "moment";

const ListProv = () => {
  const [salesData, setSalesData] = useState(null);
  const [totalCommission, setTotalCommission] = useState(null);
  const [commissionPercentage, setCommissionPercentage] = useState(null);
  const [totalBorrowed, setTotalBorrowed] = useState(null);
  const [load, setLoad] = useState(true);
  const [numberOfLoansInTheMonth, setNumberOfLoansInTheMonth] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");
  const location = useLocation();
  let data = location.state;

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    setLoad(true);
    const id = data.id;
    const fetchData = async () => {
      // Define el mes actual
      const currentDate = new Date();
      const currentMonthNumber = currentDate.getMonth(); // Obtener el número del mes actual
      const currentYear = new Date().getFullYear();

      // Array con los nombres de los meses en español
      const monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      // Obtener el nombre del mes actual
      const currentMonthName = monthNames[currentMonthNumber];
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SALES_SUPPLIER}/${id}?month=${currentMonthName}&year=${currentYear}`,
        );

        const salesTotalData = response.data.salesTotal;

        if (response.status === 204) {
          setLoad(false);
          setSalesData(null);
          setTotalCommission(null);
          setNumberOfLoansInTheMonth(null);
          setTotalBorrowed(null);
          setCommissionPercentage(null);
        } else {
          setLoad(false);
          setSalesData(response.data.sales);
          setTotalCommission(salesTotalData.totalCommission);
          setNumberOfLoansInTheMonth(salesTotalData.NumberOfLoansInTheMonth);
          setTotalBorrowed(salesTotalData.totalBorrowed);
          setCommissionPercentage(salesTotalData.commissionPercentage);
        }
      } catch (error) {
        setLoad(false);
        setSalesData(null);
        setTotalCommission(null);
        setNumberOfLoansInTheMonth(null);
        setCommissionPercentage(null);
        setTotalBorrowed(null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectYear(event.target.value);
  };

  const handleFilterClick = async () => {
    setLoad(true);
    const id = data.id;
    const monthString = selectedMonth;
    const year = selectYear;

    if (monthString === "" || year === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor seleccione mes y año",
      });
      setLoad(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SALES_SUPPLIER}/${id}`,
        {
          params: {
            monthString: monthString,
            year: year,
          },
        },
      );

      const salesTotalData = response.data.salesTotal;

      if (response.status === 204) {
        setLoad(false);
        setSalesData(null);
        setTotalCommission(null);
        setNumberOfLoansInTheMonth(null);
        setTotalBorrowed(null);
        setCommissionPercentage(null);
      } else {
        setLoad(false);
        setSalesData(response.data.sales);
        setTotalCommission(salesTotalData.totalCommission);
        setNumberOfLoansInTheMonth(salesTotalData.NumberOfLoansInTheMonth);
        const totalBorrowed = Number(salesTotalData.totalBorrowed);
        setTotalBorrowed(totalBorrowed);
        setCommissionPercentage(salesTotalData.commissionPercentage);
      }
    } catch (error) {
      setLoad(false);
      setSalesData(null);
      setTotalCommission(null);
      setNumberOfLoansInTheMonth(null);
      setCommissionPercentage(null);
      setTotalBorrowed(null);
    }
  };

  const handlerDownload = async (selectedMonth, selectYear, id) => {
    try {
      const db = "amebo"; // lo manejás vos
      const currentYear = new Date().getFullYear(); // si querés siempre año actual
      const yearToUse = selectYear || currentYear; // fallback al año actual si no viene

      const url = `http://vps-5626463-x.dattaweb.com/api/supplier/sales-supplier/excel?month=${selectedMonth}&year=${yearToUse}&supplierId=${id}&db=${db}`;

      const response = await axios.get(url, { responseType: "blob" });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileUrl = window.URL.createObjectURL(blob);

        let fileName = `FACTURAS${selectedMonth}${yearToUse}.xlsx`; // extensión Excel
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) fileName = match[1];
        }

        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(fileUrl);
      }
    } catch (error) {
      console.error("No se pudo descargar la factura", error);
      alert("No se pudo descargar la factura");
    }
  };

  return (
    <>
      <NavbarSupplier />
      <div className="boxfilter">
        <select
          className="selectfilterprov"
          value={selectYear}
          onChange={handleYearChange}
        >
          <option value="">Selecciona un año</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
          <option value="2029">2029</option>
          <option value="2030">2030</option>
        </select>

        <select
          className="selectfilterprov"
          value={selectedMonth}
          onChange={handleMonthChange}
        >
          <option value="">Selecciona un mes</option>
          <option value="Enero">Enero</option>
          <option value="Febrero">Febrero</option>
          <option value="Marzo">Marzo</option>
          <option value="Abril">Abril</option>
          <option value="Mayo">Mayo</option>
          <option value="Junio">Junio</option>
          <option value="Julio">Julio</option>
          <option value="Agosto">Agosto</option>
          <option value="Septiembre">Septiembre</option>
          <option value="Octubre">Octubre</option>
          <option value="Noviembre">Noviembre</option>
          <option value="Diciembre">Diciembre</option>
        </select>

        <button className="buttonfilteradmin" onClick={handleFilterClick}>
          Filtrar
        </button>
        <button
          className="buttonfilteradmin"
          onClick={() => handlerDownload(selectedMonth, selectYear, data.id)}
        >
          Descargar
        </button>
      </div>

      {!load ? (
        <>
          {salesData !== null ? (
            <div>
              <div className="backgounrdprovee">
                <div className="allboxlistprov">
                  <div className="alllistprov">
                    <div className="headerlistprov">
                      <p className="infoprovlistletter leftlistprev firsttittle">
                        Nombre del Socio
                      </p>
                      <p className="infoprovlistletter leftlistprev">
                        Cuit Socio
                      </p>
                      <p className="infoprovlistletter leftlistprev">
                        Fecha de prestamo
                      </p>
                      <p className="infoprovlistletter leftlistprev">Total</p>
                      <p className="infoprovlistletter leftlistprev">
                        Comisión
                      </p>
                      <p className="infoprovlistletter leftlistprev lastittle">
                        Cuotas
                      </p>
                    </div>

                    {salesData &&
                      salesData.map((sale, index) => (
                        <div className="headerlistprov" key={index}>
                          <p className="infoprovlistletter leftlistprev2 firsttittle">
                            {sale.nameOfPersonReceivingLoan}
                          </p>
                          <p className="infoprovlistletter bottonlistprev2">
                            {sale.cuitDebtor}
                          </p>
                          <p className="infoprovlistletter leftlistprev2">
                            {moment(sale.date).format("DD-MM-YYYY")}
                          </p>
                          <p className="infoprovlistletter leftlistprev2">
                            ${sale.amountGranted}
                          </p>
                          <p className="infoprovlistletter leftlistprev2">
                            ${sale.commission}
                          </p>
                          <p className="infoprovlistletter leftlistprev2">
                            {sale.quotas}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="bottontotallisprev">
                <div className="alltotalprovheader">
                  <p className="allinfoprovtotal leftlistprev3 firsttittle">
                    Cantidad de Prestamos en el Mes
                  </p>
                  <p className="allinfoprovtotal leftlistprev3">
                    Total Prestado
                  </p>
                  <p className="allinfoprovtotal leftlistprev3">
                    Porcentaje de Comisión
                  </p>
                  <p className="allinfoprovtotal leftlistprev3 lastittle">
                    Total de la Comisión
                  </p>
                </div>
                <div className="alltotalprovheader">
                  <p className="allinfoprovtotal bottonlistprev3">
                    {numberOfLoansInTheMonth}
                  </p>
                  <p className="allinfoprovtotal bottonlistprev3">
                    ${totalBorrowed}
                  </p>
                  <p className="allinfoprovtotal bottonlistprev3">
                    {commissionPercentage}
                  </p>
                  <p className="allinfoprovtotal bottonlistprev4">
                    ${totalCommission}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <NoListProv
              title="La información de este mes no se ha subido aún."
              Icon={RiMoneyDollarCircleFill}
            />
          )}
          <FooterIndex />
        </>
      ) : (
        <div className="loader"></div>
      )}
    </>
  );
};

export default ListProv;
